import logo from "../../style/images/blue-logo-without-tagline.svg";
import { useNavigate } from "react-router-dom";
import "../../style/css/style.css";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const ThankYou: React.FC = () => {
  const navigate = useNavigate();

  const [bookingDetails, setBookingDetails] = useState<{
    response: any;
    plan_name: string;
    pod_id: string | null;
  } | null>(null);

  const handleNextClick = () => {
    navigate("/bookings");
  };
  useEffect(() => {
    const bookingDetails = localStorage.getItem("bookingDetails");
    if (bookingDetails) {
      const parsedDetails = JSON.parse(bookingDetails);
      setBookingDetails(parsedDetails);
    }
  }, []);

  return (
    <div className="flex-container bg-black">
      <motion.div
        className="thank-you-container bg-white flex-grow p-[14px]"
        initial={{ opacity: 0, y: -75 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 75 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <div className="flex flex-col items-center">
          <div className="mb-6 rounded-md">
            <motion.img
              src={logo}
              alt="urban naps"
              style={{ width: "139px", height: "73px" }}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
            />
          </div>
          <motion.div
            className="text-base text-center text-[#2A2A34] font-semibold -mt-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Thank you for booking your {bookingDetails?.plan_name}
          </motion.div>
          <div className="text-sm text-[#9B9696] font-medium my-3">
            Have a great Nap!
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <motion.button
            className={`confirm-button hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg w-[330px] text-sm bg-[#0E97E6]`}
            onClick={handleNextClick}
            whileTap={{ scale: 0.95 }}
          >
            NEXT
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default ThankYou;
